import React, { useEffect, useState } from "react";
import { Save, UserRound } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function PlatformOwnerProfile() {
  const { user, refresh } = useAuth();
  const [name, setName] = useState(user?.name || "");
  const [saving, setSaving] = useState(false);

  useEffect(() => { setName(user?.name || ""); }, [user?.name]);

  const save = async (event) => {
    event.preventDefault();
    const normalized = name.trim().replace(/\s+/g, " ");
    if (normalized.length < 2) return toast.error("Nama minimal 2 karakter");
    setSaving(true);
    try {
      await api.put("/admin/platform-profile", { name: normalized });
      await refresh();
      toast.success("Nama Platform Owner berhasil diperbarui");
    } catch (error) {
      toast.error(typeof error?.response?.data?.detail === "string" ? error.response.data.detail : "Nama Platform Owner gagal diperbarui");
    } finally { setSaving(false); }
  };

  return (
    <section className="mt-8 rounded-3xl border border-slate-200 bg-white p-6 shadow-sm lg:p-7" data-testid="platform-owner-profile-section">
      <div className="flex items-start gap-4">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-blue-50 text-blue-600"><UserRound className="h-5 w-5" /></div>
        <div className="flex-1">
          <div className="text-xs font-bold uppercase tracking-[0.18em] text-blue-600">Profil Platform Owner</div>
          <h2 className="mt-1 text-xl font-black text-slate-950">Nama yang tampil di platform</h2>
          <p className="mt-1 text-sm leading-6 text-slate-500">Perubahan nama akan digunakan pada sidebar dan identitas akun Platform Owner.</p>
        </div>
      </div>
      <form onSubmit={save} className="mt-6 flex flex-col gap-3 sm:flex-row">
        <input value={name} onChange={(e)=>setName(e.target.value)} minLength={2} maxLength={120} required className="min-w-0 flex-1 rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm font-semibold outline-none focus:border-blue-500 focus:bg-white focus:ring-4 focus:ring-blue-100" placeholder="Nama Platform Owner" data-testid="platform-owner-name-input" />
        <button type="submit" disabled={saving || name.trim().length < 2} className="inline-flex items-center justify-center gap-2 rounded-2xl bg-slate-950 px-5 py-3 text-sm font-bold text-white hover:bg-blue-600 disabled:opacity-50" data-testid="platform-owner-name-save"><Save className="h-4 w-4" />{saving ? "Menyimpan..." : "Simpan Nama"}</button>
      </form>
    </section>
  );
}
